import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GraphqlModule } from '@asp/graphql';
import { AuthenticationModule } from '@asp/authentication';

@NgModule({
  declarations: [],
  imports: [CommonModule, GraphqlModule, AuthenticationModule],
})
export class CoreModule {}
